import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let FolderPermissionModelImpl = class FolderPermissionModelImpl {
    constructor() {
        this._folderPermission = proxy(null);
    }
    get folderPermission() {
        return this._folderPermission.value;
    }
    updateFolderPermission(folderPermission) {
        this._folderPermission.value = {
            ...folderPermission,
        };
    }
    subscribeFolderPermission(callback) {
        const dispose = subscribe(() => this._folderPermission.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
FolderPermissionModelImpl = __decorate([
    injectable()
], FolderPermissionModelImpl);
export { FolderPermissionModelImpl };
